<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { fade } from "svelte/transition";
  import { circInOut } from "svelte/easing";
  import { appendToBody } from "./utils";

  const dispatch = createEventDispatcher();

  export let open: boolean;
  export let disableAutoClose: boolean;

  function handleKeydown(e: KeyboardEvent) {
    if (e.key === "Escape") close(true);
  }

  function close(autoClose?: boolean) {
    if (autoClose && disableAutoClose) return;
    if (open) {
      open = false;
      dispatch("close");
    }
  }

  const overlay = {
    close,
    update() {},
  };
</script>

<svelte:window on:keydown={handleKeydown} />

<div use:appendToBody>
  {#if open}
    <div class="modal-overlay modal-zindex" on:click|self={(_) => close(true)} transition:fade={{ duration: 200, easing: circInOut }}>
      <div class="modal">
        <div class="modal-title">
          <slot name="title" />
          <div class="modal-close" on:click={(_) => close()} />
        </div>
        <div class="modal-body">
          <slot {overlay} />
        </div>
        <div class="modal-footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  {/if}
</div>

<style lang="scss" global>
  .modal-zindex {
    z-index: 10000000;
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(#000, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal {
    position: relative;
    width: 600px;
    height: max-content;
    max-width: calc(100% - 1rem);
    max-height: calc(100% - 15rem);
    display: flex;
    flex-flow: column;
    background-color: #fff;
    box-shadow: 0px 2px 35px -2px rgba(0, 0, 0, 0.15);
    border-radius: 22px;
    overflow: hidden;
  }

  .modal-title {
    position: relative;
    padding: 20px;
    color: #000;
    font-weight: bold;
    border-bottom: solid 1px #d9d9d9;
  }

  .modal-body {
    position: relative;
    padding: 20px;
    overflow: auto;
    // firefox
    scrollbar-color: rgba(#000, 0.5) transparent;
    scrollbar-width: thin;
    scrollbar-width: 5px;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: rgba(#000, 0.5);
    }
  }

  .modal-footer {
    position: relative;
    padding: 20px;
    border-top: solid 1px #d9d9d9;
  }

  .modal-close {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -15px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 50%;
    transition: all ease 200ms;

    &:hover {
      background-color: rgb(#000, 0.06);
    }

    &:after {
      content: "";
      display: inline-block;
      width: 0.9em;
      height: 0.9em;
      $close-color: #000;
      background: linear-gradient(45deg, transparent 0%, transparent 46%, $close-color 47%, $close-color 53%, transparent 54%, transparent 100%),
        linear-gradient(-45deg, transparent 0%, transparent 46%, $close-color 47%, $close-color 53%, transparent 54%, transparent 100%);
      vertical-align: middle;
    }
  }
</style>
